import React from 'react';
import { AlternativePrice, Price } from 'src/types';
import { ShippingLabel as ShippingLabelComponent } from 'src/components/shipping-label';
import { PriceDisplay } from 'src/components/price-list/types';
import { FontEmphasis } from '@prisjakt/ui/text';
import { usePriceRowContext } from 'src/areas/product/components/price-list/price-row-context';
import { OptionTypeEnum } from 'src/components/filter-dropdown';

interface IShippingLabel {
  className?: string;
  emphasis?: FontEmphasis;
  priceDisplay: PriceDisplay;
  offer: Price | AlternativePrice;
}

export const ShippingLabel: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IShippingLabel>
>> = props => {
  const {
    className,
    emphasis = FontEmphasis.MEDIUM,
    priceDisplay,
    offer,
  } = props;

  const { sorting } = usePriceRowContext();

  if (!offer || !offer.price) {
    return null;
  }

  const getShippingPrice = () => {
    if (sorting === OptionTypeEnum.CHEAPEST_PRICE) {
      return offer.shipping?.cheapest?.shippingCost;
    }

    return offer.shipping?.fastest?.shippingCost;
  };

  return (
    <ShippingLabelComponent
      className={className}
      emphasis={emphasis}
      exclShipping={offer.price.exclShipping || 0}
      shippingInfo={getShippingPrice()}
      priceDisplay={priceDisplay}
    />
  );
};
